<template>
  <el-dialog :visible.sync="centerDialogVisible" width="440px">
    <span class="title">暂时无法删除此类角色</span>
    <span class="notdelect" id="notdelect">已将部分管理员分配为此角色。请将这些管理员更换为其他角色或删除对应的管理员后，再进行删除操作。</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      limitContent: ""
    };
  },
  methods: {
    init() {
      this.centerDialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .title {
    display: block;
    font-size: 16px;
    color: #323232;
    font-weight: 500;
  }
  .notdelect {
    font-size: 14px;
    color: #999999;
    margin-top: 10px;
    display: block;
    text-align: center !important;
  }
  .el-dialog__header {
    padding: 10px;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 30px 40px;
    padding-bottom: 23px;
  }
  .el-dialog__footer {
    text-align: center !important;
    .el-button {
      background-color: #2479ed;
      color:#fff
    }
  }
}
.el-main {
  text-align: left;
}
#notdelect {
  text-align: left;
}
</style>